// src/extenders/toggle-handler.js
if (!customElements.get("toggle-button")) {
  class ToggleElements extends HTMLElement {
    constructor() {
      var _a;
      super();
      this.options = {
        classToToggle: "toggle--is-active",
        triggerToggle: "",
        target: "body",
        onHover: false,
        hoverDelay: 0,
        preventDefault: true,
        stopPropagation: true,
        ariaExpanded: false,
        rotateIcon: false
      };
      if ((_a = this == null ? void 0 : this.dataset) == null ? void 0 : _a.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }
      this.reducer = {
        click: (e) => this.debounceClickEvents(e),
        mouseEnter: (e) => this.debounceClickEvents(e, "add"),
        mouseLeave: (e) => this.debounceClickEvents(e, "remove")
      };
      this.construct();
    }
    construct() {
      this.target = document.querySelector(this.options.target);
      if (!this.target) {
        return false;
      }
      this.removeEventListener("click", this.reducer.click);
      this.addEventListener("click", this.reducer.click);
      if (this.options.onHover) {
        this.removeEventListener("mouseenter", this.reducer.mouseEnter);
        this.addEventListener("mouseleave", this.reducer.mouseLeave);
      }
    }
    debounceClickEvents(e) {
      if (!e) {
        return false;
      }
      this.preventDefault(e);
      this.stopPropagation(e);
      this.toggle();
    }
    debounceOnMouse(e, type) {
      if (!e) {
        return false;
      }
      const debouncer = debounce((type2) => {
        switch (type2) {
          case "add":
            this.add();
            break;
          case "remove":
            this.remove();
            break;
          default:
            this.toggle();
            break;
        }
      }, this.options.hoverDelay);
      debouncer(type);
    }
    preventDefault(e) {
      if (this.options.preventDefault) {
        e.preventDefault();
      }
    }
    // @param e {object}: click event
    stopPropagation(e) {
      if (this.options.stopPropagation) {
        e.stopPropagation();
      }
    }
    add() {
      const { classToToggle, triggerToggle } = this.options;
      if (this.target) {
        this.target.classList.add(classToToggle);
      }
      if (triggerToggle) {
        this.classList.add(triggerToggle);
      }
      if (this.options.ariaExpanded) {
        this.setAttribute("aria-expanded", true);
      }
      if (this.options.rotateIcon) {
        this.rotateIcon();
      }
    }
    remove() {
      const { classToToggle, triggerToggle } = this.options;
      if (this.target) {
        this.target.classList.remove(classToToggle);
      }
      if (triggerToggle) {
        this.classList.remove(triggerToggle);
      }
      if (this.options.ariaExpanded) {
        this.setAttribute("aria-expanded", false);
      }
      if (this.options.rotateIcon) {
        this.rotateIcon();
      }
    }
    toggle() {
      const { classToToggle } = this.options;
      if (!this.target) {
        return false;
      }
      if (!this.target.classList.contains(classToToggle)) {
        this.add();
      } else {
        this.remove();
      }
    }
    rotateIcon() {
      const toggleIcon = this.querySelector("svg");
      if (toggleIcon) {
        toggleIcon.classList.toggle("icon-toggle");
      }
    }
  }
  window.ToggleElements = ToggleElements;
  customElements.define("toggle-button", ToggleElements);
}
